import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum UIPreviewKey {
  SYSTEM_SETTINGS = 'system-settings',
}

const PREFIX = '@preview-ui/';

@Injectable({
  providedIn: 'root'
})
export class UIPreviewToggleService {
  previewToggled$ = new Subject<{ key: UIPreviewKey, enabled: boolean }>();

  constructor() { }

  isPreviewEnabled(key: UIPreviewKey): boolean {
    return localStorage.getItem(`${PREFIX}${key}`) === 'true' ? true : false;
  }

  togglePreview(key: UIPreviewKey, enabled: boolean) {
    if (!key) {
      console.warn('No key provided to togglePreview');
      return;
    }
    localStorage.setItem(`${PREFIX}${key}`, enabled.toString());
    this.previewToggled$.next({ key, enabled });
  }
}
